import * as yup from 'yup';

let loanSchema = yup.object().shape({
  amountToBorrow: yup
    .number()
    .moreThan(5000)
    .positive()
    .integer()
    .required('Amount must be above 5000 Naira'),
  interest: yup.number().positive().integer().required('Cannot be empty'),
  yearsInmonths: yup.number().positive().integer().required('Cannot be empty'),
});

export { loanSchema };
